<template>
    <div>
        <div class="app-title">
            <div>
                <h2>{{$t('tlt.fm.furnaceTempEdit')}}</h2>
                <ul class="app-breadcrumb breadcrumb">
                    <li class="breadcrumb-item"><router-link to="/"><i class="fa fa-home"></i></router-link></li>
                    <li class="breadcrumb-item"><router-link to="/prd/furnaceTemperature"><span>{{$t('tlt.furnaceTemperature')}}</span></router-link></li>
                    <li class="breadcrumb-item"><router-link to="/prd/furnaceTemperature/edit"><span>{{$t('tlt.fm.furnaceTempEdit')}}</span></router-link></li>
                </ul>
            </div>
            <div class="col-lg-4">
                <div class="float-lg-right">
                    <button class="btn btn-outline-secondary mr-1" type="button" v-on:click="MMFbackToList('furnaceTemperature')"><i
                            class="fa fa-fw fa-lg fa-minus-circle"></i><span
                            class=text>{{$t('btn.basic.cancel')}}</span></button>
                    <button class="btn btn-primary" type="button" v-on:click="MMFSave('furnaceTemperature')"><i
                            class="fa fa-fw fa-lg fa-save"></i><span class=text>{{$t('btn.basic.save')}}</span></button>
                </div>
            </div>
        </div>

        <section class="app-content">
            <form>
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <div class="form-group col-md-2">
                                <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.basic.date')}}：</label>
                                <mmf-datepicker v-model="day"></mmf-datepicker>
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.basic.datetime')}}：</label>
                                <!-- <input class="form-control form-control-sm" type="time" v-model="time" name="time"> -->
                                <mes-time-picker v-model="time"></mes-time-picker>
                            </div>
                            <div class="form-group col-md-2" style="display: none">
                                <label class="control-label"><span
                                        class="lbl-obg">*</span>location id:</label>
                                <dimSearch  validate="required" name="locId"
                                            v-model="locId" :entity="locations" submitProp="id" bindProp="id" bindId="smeltingLocation">
                                </dimSearch>                                
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span
                                        class="lbl-obg">*</span>{{$t('lbl.location.area')}}:</label>
                                <dimSearch  validate="required" name="locName"
                                            v-model="locName" :entity="locations" submitProp="locName" bindProp="locName" bindId="smeltingLocation">
                                </dimSearch>                                
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.basic.furnaceName')}}：</label>
                                <select class="form-control" v-model="furnaceNumber" name="furnaceNumber" v-validate="'required'">
                                        <option value>{{$t("lbl.basic.select.one")}}</option>
                                        <option value="1">{{ $t("opt.furnaceNumber1") }}</option>
                                        <option value="2">{{ $t("opt.furnaceNumber2") }}</option>
                                        <option value="3">{{ $t("opt.furnaceNumber3") }}</option>
                                        <option value="4">{{ $t("opt.furnaceNumber4") }}</option>
                                        <option value="5">{{ $t("opt.furnaceNumber5") }}</option>
                                        <option value="6">{{ $t("opt.furnaceNumber6") }}</option>
                                </select>
                                <span v-show="errors.has('furnaceNumber')" class="lbl-obg">
                                    {{errors.first('furnaceNumber')}}
                                </span>
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.furnaceTemperature.position12C')}}：</label>
                                <input class="form-control form-control-sm" type="text" v-model="position12C" name="position12C" v-validate="'required'">
                                <span v-show="errors.has('position12C')" class="lbl-obg">
                                    {{errors.first('position12C')}}
                                </span>
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.furnaceTemperature.position12H')}}：</label>
                                <input class="form-control form-control-sm" type="text" v-model="position12H" name="position12H" v-validate="'required'">
                                <span v-show="errors.has('position12H')" class="lbl-obg">
                                    {{errors.first('position12H')}}
                                </span>
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.furnaceTemperature.position22C')}}：</label>
                                <input class="form-control form-control-sm" type="text" v-model="position22C" name="position22C" v-validate="'required'">
                                <span v-show="errors.has('position22C')" class="lbl-obg">
                                    {{errors.first('position22C')}}
                                </span>
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.furnaceTemperature.position22H')}}：</label>
                                <input class="form-control form-control-sm" type="text" v-model="position22H" name="position22H" v-validate="'required'">
                                <span v-show="errors.has('position22H')" class="lbl-obg">
                                    {{errors.first('position22H')}}
                                </span>
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.furnaceTemperature.position32C')}}：</label>
                                <input class="form-control form-control-sm" type="text" v-model="position32C" name="position32C" v-validate="'required'">
                                <span v-show="errors.has('position32C')" class="lbl-obg">
                                    {{errors.first('position32C')}}
                                </span>
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.furnaceTemperature.position32H')}}：</label>
                                <input class="form-control form-control-sm" type="text" v-model="position32H" name="position32H" v-validate="'required'">
                                <span v-show="errors.has('position32H')" class="lbl-obg">
                                    {{errors.first('position32H')}}
                                </span>
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.furnaceTemperature.position150C')}}：</label>
                                <input class="form-control form-control-sm" type="text" v-model="position150C" name="position150C" v-validate="'required'">
                                <span v-show="errors.has('position150C')" class="lbl-obg">
                                    {{errors.first('position150C')}}
                                </span>
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.furnaceTemperature.position150H')}}：</label>
                                <input class="form-control form-control-sm" type="text" v-model="position150H" name="position150H" v-validate="'required'">
                                <span v-show="errors.has('position150H')" class="lbl-obg">
                                    {{errors.first('position150H')}}
                                </span>
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.furnaceTemperature.position152C')}}：</label>
                                <input class="form-control form-control-sm" type="text" v-model="position152C" name="position152C" v-validate="'required'">
                                <span v-show="errors.has('position152C')" class="lbl-obg">
                                    {{errors.first('position152C')}}
                                </span>
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.furnaceTemperature.position152H')}}：</label>
                                <input class="form-control form-control-sm" type="text" v-model="position152H" name="position152H" v-validate="'required'">
                                <span v-show="errors.has('position152H')" class="lbl-obg">
                                    {{errors.first('position152H')}}
                                </span>
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.furnaceTemperature.position153C')}}：</label>
                                <input class="form-control form-control-sm" type="text" v-model="position153C" name="position153C" v-validate="'required'">
                                <span v-show="errors.has('position153C')" class="lbl-obg">
                                    {{errors.first('position153C')}}
                                </span>
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.furnaceTemperature.position153H')}}：</label>
                                <input class="form-control form-control-sm" type="text" v-model="position153H" name="position153H" v-validate="'required'">
                                <span v-show="errors.has('position153H')" class="lbl-obg">
                                    {{errors.first('position153H')}}
                                </span>
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.furnaceTemperature.position155C')}}：</label>
                                <input class="form-control form-control-sm" type="text" v-model="position155C" name="position155C" v-validate="'required'">
                                <span v-show="errors.has('position155C')" class="lbl-obg">
                                    {{errors.first('position155C')}}
                                </span>
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.furnaceTemperature.position155H')}}：</label>
                                <input class="form-control form-control-sm" type="text" v-model="position155H" name="position155H" v-validate="'required'">
                                <span v-show="errors.has('position155H')" class="lbl-obg">
                                    {{errors.first('position155H')}}
                                </span>
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.furnaceTemperature.position250C')}}：</label>
                                <input class="form-control form-control-sm" type="text" v-model="position250C" name="position250C" v-validate="'required'">
                                <span v-show="errors.has('position250C')" class="lbl-obg">
                                    {{errors.first('position250C')}}
                                </span>
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.furnaceTemperature.position250H')}}：</label>
                                <input class="form-control form-control-sm" type="text" v-model="position250H" name="position250H" v-validate="'required'">
                                <span v-show="errors.has('position250H')" class="lbl-obg">
                                    {{errors.first('position250H')}}
                                </span>
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.furnaceTemperature.position251C')}}：</label>
                                <input class="form-control form-control-sm" type="text" v-model="position251C" name="position251C" v-validate="'required'">
                                <span v-show="errors.has('position251C')" class="lbl-obg">
                                    {{errors.first('position251C')}}
                                </span>
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.furnaceTemperature.position251H')}}：</label>
                                <input class="form-control form-control-sm" type="text" v-model="position251H" name="position251H" v-validate="'required'">
                                <span v-show="errors.has('position251H')" class="lbl-obg">
                                    {{errors.first('position251H')}}
                                </span>
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.furnaceTemperature.position252C')}}：</label>
                                <input class="form-control form-control-sm" type="text" v-model="position252C" name="position252C" v-validate="'required'">
                                <span v-show="errors.has('position252C')" class="lbl-obg">
                                    {{errors.first('position252C')}}
                                </span>
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.furnaceTemperature.position252H')}}：</label>
                                <input class="form-control form-control-sm" type="text" v-model="position252H" name="position252H" v-validate="'required'">
                                <span v-show="errors.has('position252H')" class="lbl-obg">
                                    {{errors.first('position252H')}}
                                </span>
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.furnaceTemperature.position253C')}}：</label>
                                <input class="form-control form-control-sm" type="text" v-model="position253C" name="position253C" v-validate="'required'">
                                <span v-show="errors.has('position253C')" class="lbl-obg">
                                    {{errors.first('position253C')}}
                                </span>
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.furnaceTemperature.position253H')}}：</label>
                                <input class="form-control form-control-sm" type="text" v-model="position253H" name="position253H" v-validate="'required'">
                                <span v-show="errors.has('position253H')" class="lbl-obg">
                                    {{errors.first('position253H')}}
                                </span>
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.furnaceTemperature.position254C')}}：</label>
                                <input class="form-control form-control-sm" type="text" v-model="position254C" name="position254C" v-validate="'required'">
                                <span v-show="errors.has('position254C')" class="lbl-obg">
                                    {{errors.first('position254C')}}
                                </span>
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.furnaceTemperature.position254H')}}：</label>
                                <input class="form-control form-control-sm" type="text" v-model="position254H" name="position254H" v-validate="'required'">
                                <span v-show="errors.has('position254H')" class="lbl-obg">
                                    {{errors.first('position254H')}}
                                </span>
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.furnaceTemperature.position255C')}}：</label>
                                <input class="form-control form-control-sm" type="text" v-model="position255C" name="position255C" v-validate="'required'">
                                <span v-show="errors.has('position255C')" class="lbl-obg">
                                    {{errors.first('position255C')}}
                                </span>
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.furnaceTemperature.position255H')}}：</label>
                                <input class="form-control form-control-sm" type="text" v-model="position255H" name="position255H" v-validate="'required'">
                                <span v-show="errors.has('position255H')" class="lbl-obg">
                                    {{errors.first('position255H')}}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </section>
    </div>
</template>

<script>
import {
        createHelpers
    } from 'vuex-map-fields';
    import {
        mapActions, mapState,
    } from "vuex";
    import {
        fields
    } from "@/model/prd/dailyReportMgt/FurnaceTemperature";
    import MmfDatepicker from '@/components/MmfDatepicker';
    import MesTimePicker from '@/components/MesTimePicker';
    import dimSearch from "@/components/MMFDimSearch";

    const {
        mapFields
    } = createHelpers({
        getterType: 'furnaceTemperature/getField',
        mutationType: 'furnaceTemperature/updateField',
    });
export default {
    data(){
        return {};
    },
    beforeMount() {
            this.$store.dispatch('furnaceTemperature/loadLocations');
    },
    computed: {
            ...mapFields(fields),
            ...mapState({
                locations: state => state.furnaceTemperature.locations,
            }),
        },
        methods: {
            ...mapActions("base", ["MMFbackToList", "MMFSave"]),            
        },
        components: {
            MmfDatepicker,
            MesTimePicker,
            dimSearch
        }
};
</script>